@switch (formMode) {
  @case ('memo') {
    @if (isRefreshing) {
      <div [style.height.px]="575"></div>
    }
    <div class="form-group mt-0" style="overflow: hidden">
      <label class="">{{ 'MEMOS.DETAIL' | translate }} </label>
      @if (!isRefreshing) {
        <editor
          class="zoom-editor"
          [(ngModel)]="memoData[this.inputComponent.controlName]"
          (ngModelChange)="editorChange()"
          [init]="config"
        >
        </editor>
      }
    </div>
  }

  @case ('normal') {
    @if (isRefreshing) {
      <div [style.height.px]="375"></div>
    }
    @if (!isRefreshing) {
      <editor
        class="zoom-editor editor"
        [formControl]="control"
        (onSetContent)="onSetContent($event)"
        [init]="configEditorMail"
      >
      </editor>
    }
    @if (!isRefreshing) {
      <span class="remain" [class.text-asterisk]="remain < 0">
        {{ 'EMAIL-SETTING.CHAR-REMAIN' | translate }}: {{ remain }}
      </span>
    }
  }

  @case ('contract_tc') {
    @if (isRefreshing) {
      <div [style.height.px]="375"></div>
    }
    @if (!isRefreshing) {
      <editor
        class="zoom-editor editor"
        [formControl]="control"
        (onSetContent)="onSetContent($event)"
        [init]="configContractTC"
      >
      </editor>
    }
  }
}
